<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="card">
            <div class="row">
                <div class="col-6">
                    <div class="card-body">
                        <div class="col form-group">
                            <span class="e-ctl"><strong>Les mentions légales</strong></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card-body">
                        <div class="col form-group">
                            <label>
                                La présence des <span class="e-ctl"> <strong> conditions générales de vente</strong></span>
                            sur une page accessible
                                à tous est obligatoire lorsque le site de ecommerce s'adresse à des particuliers.
                            </label>
                                <br>
                            <label> Les conditions générales de vente doivent à la fois être conformes au Code de la consommation,
                                à la règlementation de la vente à distance et à celle du commerce électronique.
                            </label>
                            <br>
                            <label>Les conditions générales de vente doivent au minimum contenir :</label>
                            <ul>
                                <label>
                                <li>les mentions relatives à l'identité du commerçant en ligne ou à l'identité de son entreprise,</li>
                                <li>les mentions relatives aux produits ou services mis en vente,</li>
                                <li>les mentions relatives au prix, à la durée de validité de l'offre et au paiement,</li>
                                <li>les mentions relatives à la livraison,</li>
                                <li>la mention relative à l'existence d'un droit de rétractation,</li>
                                <li>les mentions relatives aux garanties dont dispose l'acheteur (garantie légale de conformité et garantie des vices cachés),</li>
                                <li>les mentions relatives à la protection des données à caractère personnel,</li>
                                <li>les mentions relatives au médiateur de la consommation,</li>
                                <li>les différentes étapes à suivre pour conclure le contrat par voie électronique, ainsi que les moyens techniques permettant à l'utilisateur de corriger les éventuelles erreurs commises lors de la saisie,</li>
                                <li>les langues proposées pour la conclusion du contrat,</li>
                                <li>en cas d'archivage du contrat, les modalités de cet archivage et les conditions d'accès au contrat archivé,</li>
                                <li>les moyens de consulter les règles professionnelles et commerciales auxquelles le vendeur entend, le cas échéant, se soumettre.</li>
                                </label>
                            </ul>
                            <br>
                            <label>Nombre de vendeurs en ligne négligent la rédaction de leurs conditions générales de vente, qui comprennent souvent des clauses dites "abusives", qui créent, au détriment du consommateur, un déséquilibre significatif.</label>
                            <br>
                            <label>Les consommateurs, souvent par l'intermédiaire des associations de consommateurs, saisissent régulièrement les tribunaux pour que soient sanctionnées les clauses abusives.</label>
                            <br>
                            <label>La clause, une fois estimée abusive, sera considérée comme nulle. Le reste des conditions générales de vente restera en principe valable, sauf s'il est démontré que cette clause est essentielle pour l'exécution du contrat.</label>
                        </div>
                        <br>
                        <br>
                        <toggle-button color="#1DC8D5" v-model="val"/>
                        <span style="margin-left: 5px; color:#19aeb9;font-size: 15px;" v-if="val == true">J'accepte les conditions de vente</span>
                        <span style="margin-left: 5px; color:#878787;font-size: 15px;" v-else>Je n'accepte pas les conditions de vente</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card-body">
                        <div class="field remarque">
                            <button :disabled="val == false"
                                    @click="goToPayment()"
                                    class="btn btn-standard-gradient px-4 float-right mt-0 mb-3"
                                    type="button">
                                Accéder au paiement
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {titles} from '../../utils/general/titles.js';
    import {ToggleButton} from 'vue-js-toggle-button';
    Vue.component('ToggleButton', ToggleButton);
    export default {
        name: 'legalNotice',
        props: {},
        data() {
            return {
                titles,
                val: false
            };
        },

        methods: {
            goToPayment() {
                let id = this.$route.params.id;
                let item = this.$route.params.item;
                this.$router.push({name: 'paymentStep', params: {id, item}});
            }
        }
    };
</script>
<style>
    @import '../../assets/style/css/base.css';
</style>